<template>
  <modal
    :ignoreBackdropClick="true"
    @close="onHidden"
    :show.sync="shown"
    headerClasses="justify-content-center"
    class="modal-options order-modal"
    v-if="fromItem != null"
    modalClasses="modal-dialog-centered modal-dialog-scrollable"
  >
    <component :is="style">
      .el-input-number__decrease, .el-input-number__increase { background-color:
      {{ myTheme.customizeButton.backgroundColor }}; color:
      {{ myTheme.customizeButton.color }}; }}
    </component>
    <h4 slot="header" class="title title-up">
      {{ $t("text.adding_menu_choices") }}
    </h4>
    <cards class="menu-card">
      <alert type="danger" v-if="showAlert">
        <div class="alert-icon">
          <i class="now-ui-icons k-icon-notifications"></i>
        </div>
        <strong>{{ $t("message.resource_error_notify_title") }}</strong>
        {{ msgAlert }}
      </alert>
      <div class="d-flex flex-column">
        <el-image class="menu-item-image big" v-if="fromItem.image" :src="fromItem.image" fit="cover">
          <div slot="placeholder" class="image-slot">
            <i class="fa fa-circle-o-notch fa-spin fa-1x fa-fw"></i>
          </div>
          <div slot="error" class="image-slot text">
            <el-image class="menu-item-image w-100" src="img/menu-item-no-image.jpg" fit="cover"></el-image>
          </div>
        </el-image>
        <div class="wrapper-menu-Item">
          <div class="box favorite clickable" @click="addRemoveFavorit()">
            <i
              class="new-ui-icons"
              :class="{
                'fa fa-spinner fa-spin': isLoading,
                'k-icon-tab-favourites fav':
                  !isLoading && fromItem.is_favourite,
                'k-icon-heart-line': !isLoading && !fromItem.is_favourite,
              }"
            ></i>
          </div>
          <div class="box details">
            <p class="title" :style="{ color: myTheme.primaryTextColor }">
              {{ fromItem.name }}
            </p>
            <p class="description">{{ fromItem.description }}</p>
            <div
              class="d-inline dietry-requirements"
              v-for="(dieatry, index) in getHelpers.getMenuItemDieatriesIcons(
                fromItem
              )"
              :key="index"
            >
              <i
                class="new-ui-icons mr-1"
                :class="dieatry.icon"
                :title="dieatry.name"
              ></i>
            </div>
          </div>
          <div class="box price text-center my-auto">
            {{ getPrice | currency(currentCurrency) }}
          </div>
          <div class="box counter text-center my-auto">
            <div class="btn-group-vertical add">{{ fromItem.quantity }}</div>
          </div>
        </div>
      </div>
    </cards>
    <template>
      <div class="form-group row">
        <label for="inputEmail3" class="col-sm-4 col-form-label">{{
          $t("text.menu_quantity")
        }}</label>
        <div class="col-sm-8">
          <el-input-number
            v-model="fromItem.quantity"
            :min="fromItem.minimum_quantity"
            :max="enumHelper.maxItems"
          ></el-input-number>
        </div>
      </div>
    </template>
    <template>
      <div
        class="option"
        v-for="(option, index) in fromItem.options"
        :key="index"
      >
        <p>
          {{ option.name }}
          <span class="required" v-if="option.is_required">*</span>
        </p>
        <div v-if="option.type == 'RADIO'" class="sub-option">
          <div class="btn-group">
            <n-radio-button
              :styleClass="myTheme.standardRadioButton"
              v-for="(value, index) in option.values"
              v-model="option.selected"
              :key="index"
              :label="value.id"
            >
              <p>{{ value.name }}</p>
              <p>+ {{ value.price | currency(currentCurrency) }}</p
              >
            </n-radio-button>
          </div>
        </div>
        <div v-if="option.type == 'CHECKBOX'" class="sub-option">
          <n-checkbox-button
            v-for="(val, index) in option.values"
            :key="index"
            v-model="option.selected"
            :value="val.id"
          >
            {{ val.name }}
            <span v-if="val.price > 0"
              >+ {{ val.price | currency(currentCurrency) }}</span
            >
          </n-checkbox-button>
        </div>
        <div
          v-if="option.type == 'SELECT'"
          class="form-group justify-content-center"
          role="group"
        >
          <el-select
            v-model="option.selected"
            :placeholder="$t('input.placeholder.select_option')"
            :clearable="true"
          >
            <el-option
              v-for="(value, index) in option.values"
              :key="index"
              :label="value.name"
              :value="value.id"
            >
              <span class="span-left">{{ value.name }}</span>
              <span class="span-right"
                >{{ $t("text.price") }} :
                {{ value.price | currency(currentCurrency) }}</span
              >
            </el-option>
          </el-select>
        </div>
      </div>
    </template>
    <template>
      <hr />
      <div class="option">
        <p>{{ $t("text.add_comment") }}</p>
        <fg-textarea
          maxlength="500"
          class="no-border"
          :placeholder="$t('input.placeholder.your_comment')"
          addon-left-icon="now-ui-icons k-icon-comment"
          v-model="fromItem.comment"
        ></fg-textarea>
      </div>
    </template>
    <template slot="footer">
      <n-button type="success" @click.native="addOptionsToOrder()">
        {{ editMode ? $t("button.update_order") : $t("button.add_to_order") }}
      </n-button>
      <n-button
        v-if="editMode"
        type="default"
        @click.native="onItemDelete(index)"
        >{{ $t("button.delete_item") }}</n-button
      >
    </template>
  </modal>
</template>
<script>
import {
  Button,
  Cards,
  Modal,
  RadioButton,
  FormTexterea,
  CheckboxButton,
  Alert,
} from "@/components";
import { InputNumber } from "element-ui";
import { helpers, enumHelper } from "@/utilities";
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  name: "order-modal",
  components: {
    [Button.name]: Button,
    Cards,
    Modal,
    Alert,
    [RadioButton.name]: RadioButton,
    [FormTexterea.name]: FormTexterea,
    [CheckboxButton.name]: CheckboxButton,
    [InputNumber.name]: InputNumber,
  },
  props: {
    fromItem: Object,
    editMode: Boolean,
    index: Number,
    orderType: Number,
  },
  data() {
    return {
      enumHelper,
      shown: false,
      isLoading: false,
      showAlert: false,
      msgAlert: "",
      getHelpers: helpers,
      style: "style",
    };
  },
  computed: {
    ...mapGetters(["isAuthenticated"]),
    ...mapState({
      user: (state) => state.auth.user,
    }),
    getPrice: function () {
      return helpers.getItemTotal(this.fromItem, this.orderType);
    },
  },
  methods: {
    addOptionsToOrder() {
      if (this.fromItem.hasOptions) {
        helpers
          .checkRequiredOptions(this.fromItem.options)
          .then((result) => {
            if (result === true) {
              this.showAlert = false;
              this.$root.$emit("PUSH_ITEM", {
                item: this.fromItem,
                openModal: false,
                editMode: this.editMode,
              });
            }
          })
          .catch((msg) => {
            this.msgAlert = msg;
            this.showAlert = true;
          });
      } else {
        this.showAlert = false;
        this.$root.$emit("PUSH_ITEM", {
          item: this.fromItem,
          openModal: false,
          editMode: this.editMode,
        });
      }
    },

    onItemDelete(_index) {
      this.$root.$emit("REMOVE_ITEM", _index);
    },
    openModal() {
      this.shown = true;
    },
    closeModal() {
      this.shown = false;
      this.showAlert = false;
    },
    ...mapActions(["addToFavorite", "deleteFavorite"]),

    addRemoveFavorit() {
      if (!this.isAuthenticated || this.user == null) {
        // TODO : redirect user to login page with current page url

        return;
      }
      this.isLoading = true;
      let obj = {
        menu_item_id: this.fromItem.menu_item_id,
        location_id: this.selectedLocation.id,
      };
      if (!this.fromItem.is_favourite) {
        this.addToFavorite(obj).then(() => {
          this.isLoading = false;
          this.fromItem.is_favourite = true;
        });
      } else {
        this.deleteFavorite(obj).then(() => {
          this.isLoading = false;
          this.fromItem.is_favourite = false;
        });
      }
    },
    onHidden() {
      this.showAlert = false;
    },
  },
};
</script>
<style scoped>
.form-group.input-group {
  padding: 0;
}
</style>
